"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FULLSCRIPT_DOMAINS = void 0;
var FULLSCRIPT_DOMAINS = {
  ca: "https://ca.fullscript.com",
  us: "https://us.fullscript.com",
  "ca-snd": "https://ca-snd.fullscript.io",
  "us-snd": "https://us-snd.fullscript.io",
  dev: "http://localhost:3000"
};
exports.FULLSCRIPT_DOMAINS = FULLSCRIPT_DOMAINS;